import React, { memo } from 'react';
import styles from './FilterField.module.scss';
import cn from 'classnames';

const FilterField = ({ label, active = false, children, className }) => (
  <div
    className={cn(styles.root, className, {
      [styles.active]: active,
    })}
  >
    {label && (
      <div className={styles.label}>
        {label}
        {active && <span className={styles.activeDot} />}
      </div>
    )}
    <div className={styles.control}>{children}</div>
  </div>
);

export default memo(FilterField);
